<template>
  <div class="bg"></div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
import {
  checkphone,
  checkempty,
  formatNickName,
  setCookie,
  getCookie,
} from "./../../assets/js/tool";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      openid: "",
    };
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    errorUrl(test) {
      if (test) {
        this.$toast({
          message: test,
          duration: 2000,
        });
      }
    },
    clearUrl(arr) {
      let url = location.href.split("?")[0];
      let query = location.search.substr(1);
      var newUrl = url;
      if (query) {
        let obj = {};
        let queryArr = query.split("&");
        for (let i = 0; i < queryArr.length; i++) {
          queryArr[i] = queryArr[i].split("=");
          obj[queryArr[i][0]] = queryArr[i][1];
        }
        arr.map((item) => {
          if (query.indexOf(item) > -1) {
            delete obj[item];
          }
        });
        if (JSON.stringify(obj) !== "{}") {
          newUrl =
            url +
            "?" +
            JSON.stringify(obj)
              .replace(/\"\,\"/g, "&")
              .replace(/[\"\{\}]/g, "")
              .replace(/\:/g, "=");
        }
      }
      return newUrl;
    },
    getWeChatCode() {
      let that = this;
      var appId = this.appId;
      var indexUrl = this.clearUrl(["code", "state"]);
      var url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appId +
        "&redirect_uri=" +
        encodeURIComponent(indexUrl) +
        "&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect";
      var code = this.getUrlParam("code");
      if (!code) {
        window.location = url;
      } else {
        this.$post("/api/wechat/gzh/code2userInfo", {
          code: code,
          type: this.appType,
        })
          .then((resp) => {
            if (resp.code == "200") {
              let datas = resp.object.resp;
              if (datas.resp_code == 0 && datas.resp_result == 0) {
                that.openid = datas.openid;
                that.getWechatUserInfo(datas.accessToken);
              } else {
                that.errorUrl("登录失败！");
              }
            } else {
              if (resp.code == "440") {
                return (window.location = url);
              }
              that.errorUrl("登录失败！");
            }
          })
          .catch((err) => {
            that.errorUrl("您现在的网络不稳定，请稍后再试");
          });
      }
    },
    getWechatUserInfo(token) {
      let that = this;
      this.$fetch(
        "/weChatApi/sns/userinfo?access_token=" +
          token +
          "&openid=" +
          this.openid +
          "&lang=zh_CN"
      )
        .then((data) => {
          if (data.unionid) {
            data.nickname = formatNickName(data.nickname);
            localStorage.setItem("unionid", data.unionid);
            if (!data.headimgurl || data.headimgurl == "") {
              data.headimgurl =
                this.cdnImgPath + "/images/default/wx_head_default.jpg";
            }
            let obj = {
              unionid: data.unionid,
              openid: that.openid,
              nickname: data.nickname || "粉丝",
              headimgUrl: data.headimgurl,
            };
            that.wxLogin(obj, "loginRegister");
          } else {
            that.errorUrl("登录失败");
            setTimeout(() => {
              WeixinJSBridge.call("closeWindow");
            }, 1500);
          }
        })
        .catch((err) => {
          that.errorUrl("您现在的网络不稳定，请稍后再试");
        });
    },
    getRouterItem(str) {
      let newObj = {
        path: "",
        query: {},
      };
      if (str) {
        let path = str.split("?")[0];
        let query = str.split("?")[1];
        let obj = {};
        if (query) {
          let queryArr = query.split("&");
          for (let i = 0; i < queryArr.length; i++) {
            queryArr[i] = queryArr[i].split("=");
            obj[queryArr[i][0]] = queryArr[i][1];
          }
        }
        newObj.path = path;
        newObj.query = obj;
      }
      return newObj;
    },
    wxLogin(data, type) {
      let beforeLoginUrl = localStorage.getItem("beforeLoginUrl") || "/index";
      let routerItem = this.getRouterItem(beforeLoginUrl);
      let supNbr = decodeURIComponent(routerItem.query.supNbr || "");
      if (supNbr.indexOf("nbr=") > -1) {
        routerItem.query.supNbr = supNbr.split("nbr=")[0];
        routerItem.query.nbr = supNbr.split("nbr=")[1];
        supNbr = supNbr.split("nbr=")[0];
      }
      let that = this;
      this.$post(`/api/customer/gzh/${type}`, {
        nickName: encodeURIComponent(data.nickname),
        headImg: encodeURIComponent(data.headimgUrl),
        openId: that.openid,
        unionId: data.unionid,
        shareUserNbr: supNbr,
      })
        .then((res) => {
          if (res.code == "200") {
            let resp = res.object.resp;
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              if (!resp.sup_user_nbr) {
                this.$post("/api/customer/updateSupUser", {
                  userNbr: resp.user_nbr,
                  supUserNbr: supNbr,
                })
                  .then((resp) => {})
                  .catch((err) => {});
              }
              let userInfo = {
                nbr: resp.user_nbr,
                imgUrl: data.headimgUrl,
                name: data.nickname,
                phoneNo: resp.phone_no,
              };
              localStorage.setItem("openid", that.openid);
              that.senduserInfo(userInfo);
              localStorage.setItem("is_new_coupon", resp.is_new_coupon);
              let backUrl;
              if (beforeLoginUrl) {
                routerItem.query.supNbr = resp.user_nbr;
                backUrl =
                  routerItem.path +
                  "?" +
                  JSON.stringify(routerItem.query)
                    .replace(/\"\,\"/g, "&")
                    .replace(/[\"\{\}]/g, "")
                    .replace(/\:/g, "=");
              } else {
                backUrl =
                  location.origin + "/index?" + "supNbr=" + resp.user_nbr;
              }
              localStorage.removeItem("beforeLoginUrl");
              this.$router.push(backUrl);
            } else {
              that.errorUrl(resp.resp_msg);
            }
          } else {
            that.errorUrl(res.message);
          }
        })
        .catch((err) => {
          that.errorUrl("您现在的网络不稳定，请稍后再试");
        });
    },
    outWechat() {
      WeixinJSBridge.call("closeWindow");
    },
   },
  created(){
    sessionStorage.setItem("showNewCard", '0');
    sessionStorage.setItem("showGroup", '0');
    this.getWeChatCode();
	  // let userInfo = {
    //   nbr: '101608',//101552
    // };
    // localStorage.setItem("openid", 'olcmO1bChIbz62WXmV6KZxKK3ds8');
    // this.senduserInfo(userInfo);
    // let backUrl = '/index?'+'supNbr='+ userInfo.nbr
    // // let backUrl = '/payResultFollow?orderNbr=1797&'+'supNbr='+ userInfo.nbr
    // this.$router.push(backUrl)
  },
  mounted() {
    // if (typeof WeixinJSBridge == "undefined") {
    //   if (document.addEventListener) {
    //     document.addEventListener(
    //       "WeixinJSBridgeReady",
    //       this.outWechat,
    //       false
    //     );
    //   } else if (document.attachEvent) {
    //     document.attachEvent("WeixinJSBridgeReady", this.outWechat);
    //     document.attachEvent("onWeixinJSBridgeReady", this.outWechat);
    //   }
    // }
  },
  destroyed() {},
};
</script>
<style scoped lang='less'>
.bg {
  width: 100%;
  background: #fff;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/index/login.vue